import { Box, Typography } from '@mui/material'

const SectionHeader = ({ title }: { title: string }) => (
  <Box
    sx={{
      px: 2,
      py: 1,
      bgcolor: 'primary.main',
      color: 'primary.contrastText',
      borderBottom: 1,
      borderColor: 'divider',
    }}
  >
    <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
      {title}
    </Typography>
  </Box>
)

export default SectionHeader
